module.exports = __webpack_public_path__ + "static/media/ET226 new.00709cec.jpg";